import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'research-repository.field-1-name': {
    id: 'research-repository.field-1-name',
    defaultMessage: 'Research plan',
    description:
      'The field name (and the default value/watermark) in field #1 for this database template. In this case: Research plan'
  },
  'research-repository.field-2-name': {
    id: 'research-repository.field-2-name',
    defaultMessage: 'Method',
    description:
      'The field name (and the default value/watermark) in field #2 for this database template. In this case: Method'
  },
  'research-repository.field-2-select-option-1': {
    id: 'research-repository.field-2-select-option-1',
    defaultMessage: 'Survey',
    description:
      'The option value for option #1 in field #2 for this database template. In this case: Survey'
  },
  'research-repository.field-2-select-option-2': {
    id: 'research-repository.field-2-select-option-2',
    defaultMessage: '1:1 interviews',
    description:
      'The option value for option #2 in field #2 for this database template. In this case: 1:1 interviews'
  },
  'research-repository.field-2-select-option-3': {
    id: 'research-repository.field-2-select-option-3',
    defaultMessage: 'Observation',
    description:
      'The option value for option #3 in field #2 for this database template. In this case: Observation'
  },
  'research-repository.field-2-select-option-4': {
    id: 'research-repository.field-2-select-option-4',
    defaultMessage: 'Focus group',
    description:
      'The option value for option #4 in field #2 for this database template. In this case: Focus group'
  },
  'research-repository.field-2-select-option-5': {
    id: 'research-repository.field-2-select-option-5',
    defaultMessage: 'Experiment',
    description:
      'The option value for option #5 in field #2 for this database template. In this case: Experiment'
  },
  'research-repository.field-3-name': {
    id: 'research-repository.field-3-name',
    defaultMessage: 'Objective',
    description:
      'The field name (and the default value/watermark) in field #3 for this database template. In this case: Objective'
  },
  'research-repository.field-4-name': {
    id: 'research-repository.field-4-name',
    defaultMessage: 'Status',
    description:
      'The field name (and the default value/watermark) in field #4 for this database template. In this case: Status'
  },
  'research-repository.field-4-select-option-1': {
    id: 'research-repository.field-4-select-option-1',
    defaultMessage: 'To do',
    description:
      'The option value for option #1 in field #4 for this database template. In this case: To do'
  },
  'research-repository.field-4-select-option-2': {
    id: 'research-repository.field-4-select-option-2',
    defaultMessage: 'Planning',
    description:
      'The option value for option #2 in field #4 for this database template. In this case: Planning'
  },
  'research-repository.field-4-select-option-3': {
    id: 'research-repository.field-4-select-option-3',
    defaultMessage: 'In progress',
    description:
      'The option value for option #3 in field #4 for this database template. In this case: In progress'
  },
  'research-repository.field-4-select-option-4': {
    id: 'research-repository.field-4-select-option-4',
    defaultMessage: 'Complete',
    description:
      'The option value for option #4 in field #4 for this database template. In this case: Complete'
  },
  'research-repository.field-4-select-option-5': {
    id: 'research-repository.field-4-select-option-5',
    defaultMessage: 'Paused',
    description:
      'The option value for option #5 in field #4 for this database template. In this case: Paused'
  },
  'research-repository.field-5-name': {
    id: 'research-repository.field-5-name',
    defaultMessage: 'Researcher',
    description:
      'The field name (and the default value/watermark) in field #5 for this database template. In this case: Researcher'
  },
  'research-repository.field-6-name': {
    id: 'research-repository.field-6-name',
    defaultMessage: 'Resources',
    description:
      'The field name (and the default value/watermark) in field #6 for this database template. In this case: Resources'
  },
  'research-repository.field-7-name': {
    id: 'research-repository.field-7-name',
    defaultMessage: 'Findings',
    description:
      'The field name (and the default value/watermark) in field #7 for this database template. In this case: Findings'
  },
  'research-repository.view-1-name': {
    id: 'research-repository.view-1-name',
    defaultMessage: 'All research',
    description:
      'The view name for view #1 in this template. Displayed on the top left of the screen (below the database name). In this case: All research'
  },
  'research-repository.entry-1-cell-1': {
    id: 'research-repository.entry-1-cell-1',
    defaultMessage: 'Customer survey',
    description:
      'The text value of cell #1 in row (entry) #1 in this database template. In this case:  Customer survey'
  },
  'research-repository.entry-1-cell-3': {
    id: 'research-repository.entry-1-cell-3',
    defaultMessage: 'Understand customer interest',
    description:
      'The text value of cell #3 in row (entry) #1 in this database template. In this case:  Understand customer interest'
  },
  'research-repository.entry-2-cell-1': {
    id: 'research-repository.entry-2-cell-1',
    defaultMessage: 'SEQ testing',
    description:
      'The text value of cell #1 in row (entry) #2 in this database template. In this case:  SEQ testing'
  },
  'research-repository.entry-2-cell-3': {
    id: 'research-repository.entry-2-cell-3',
    defaultMessage: 'Test the product’s ease of use',
    description:
      'The text value of cell #3 in row (entry) #2 in this database template. In this case:  Test the product’s ease of use'
  },
  'research-repository.entry-3-cell-1': {
    id: 'research-repository.entry-3-cell-1',
    defaultMessage: 'Contextual inquiry',
    description:
      'The text value of cell #1 in row (entry) #3 in this database template. In this case:  Contextual inquiry'
  },
  'research-repository.entry-3-cell-3': {
    id: 'research-repository.entry-3-cell-3',
    defaultMessage:
      'Identify issues with the customer experience that are lowering numbers',
    description:
      'The text value of cell #3 in row (entry) #3 in this database template. In this case:  Identify issues with the customer experience that are lowering numbers'
  },
  'research-repository.entry-4-cell-1': {
    id: 'research-repository.entry-4-cell-1',
    defaultMessage: 'Use case interview',
    description:
      'The text value of cell #1 in row (entry) #4 in this database template. In this case:  Use case interview'
  },
  'research-repository.entry-4-cell-3': {
    id: 'research-repository.entry-4-cell-3',
    defaultMessage: 'Gain deeper understanding of our customers’ needs',
    description:
      'The text value of cell #3 in row (entry) #4 in this database template. In this case:  Gain deeper understanding of our customers’ needs'
  },
  'research-repository.entry-5-cell-1': {
    id: 'research-repository.entry-5-cell-1',
    defaultMessage: 'Growth experiment',
    description:
      'The text value of cell #1 in row (entry) #5 in this database template. In this case:  Growth experiment'
  },
  'research-repository.entry-5-cell-3': {
    id: 'research-repository.entry-5-cell-3',
    defaultMessage: 'Test two different versions',
    description:
      'The text value of cell #3 in row (entry) #5 in this database template. In this case:  Test two different versions'
  }
});
